import type { FetchError } from "ofetch";

export type LogInRequest = {
    UserName: string;
    Password: string;
};

export type LogInResponse = {
    ReturnUrl: string;
    AntiForgeryToken: string;
};

export default function useIdentity() {
    const { $api } = useNuxtApp();
    const isAuthenticated = useStateIsAuthenticated();
    // Resist the urge to set isAuthenticated global state here, instead allow useInitializeState to take care of it.

    async function logIn(logInRequest: LogInRequest) {
        try {
            const loginResponse = await $api<LogInResponse>("identity/sign-in", {
                method: "POST",
                body: logInRequest,
            });

            return loginResponse;
        } catch (err) {
            const fetchError = err as FetchError;
            throw new Error(fetchError.data.Error);
        }
    }

    function logOut() {
        if (!isAuthenticated.value) return;

        try {
            return $api("identity/logout");
        } catch (err) {
            // session cookie possibly destroyed in another tab, assume already signed out and swallow error
            console.error(err);
        }
    }

    return { logIn, logOut };
}
